import type { TJobsReportListParams } from 'app/queries/reports/reportsKeys';

export const buildJobsReportRequest = (workspaceId: string, params: TJobsReportListParams) => ({
  wsid: workspaceId,
  pageNo: params.page.toString(),
  pageSize: params.pageSize.toString(),
  orderBy: 'createdAt',
  orderType: 'desc',
  search: params.search,
  jobsFrom: params.jobsFrom,
  jobsTo: params.jobsTo,
});
